import { Injectable } from "@angular/core";
import { LoginUser } from "../models/login-user";
import { IAuthService } from "./interface/iauthservice";

@Injectable({
  providedIn: "root"
})
export class AuthService implements IAuthService {
  //#region members and Constructors
  currentUser: LoginUser;
  redirectUrl: string;
  constructor() {}
  //#endregion

  //#region  Service API
  public login(user: LoginUser): void {
    this.currentUser = user;
  }
  public logoff(user: LoginUser): void {
    this.currentUser = null;
  }
  public isUserLogin(): boolean {
    return !!this.currentUser;
  }
  public GetLoginUser(): LoginUser {
    return this.currentUser;
  }
  public IsActor(roles: string[]): Boolean {
    return !!roles && roles.indexOf("actor") > -1;
  }
  public IsISOperator(roles: string[]): Boolean {
    return !!roles && roles.indexOf("operator") > -1;
  }
  public IsFundAdmin(roles: string[]): Boolean {
    return !!roles && roles.indexOf("fundmanager") > -1;
  }
  public IsSupervisor(roles: string[]): Boolean {
    return !!roles && roles.indexOf("supervisor") > -1;
  }
  public getUserId(): number {
    return !!this.currentUser ? this.currentUser.id : null;
  }
  //#endregion
}
